import { render, staticRenderFns } from "./Suggestions.vue?vue&type=template&id=6e1e31ec"
import script from "./Suggestions.vue?vue&type=script&lang=js"
export * from "./Suggestions.vue?vue&type=script&lang=js"
import style0 from "./Suggestions.vue?vue&type=style&index=0&id=6e1e31ec&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports